<template>
  <BTableSimple
    v-bind="$attrs"
    :headers="headers"
    :actions="filteredActions"
    class="BTablePublicationDataCollections"
    v-on="$listeners"
  >
    <template #item.form_template="{ header, data, value: v }">
      <router-link
        v-if="hasAccessToTemplates"
        :to="header.getRoute(data)"
        v-text="v"
      />
      <span v-else v-text="v" />
    </template>

    <template #item.is_scannable="{ value: v }">
      <v-icon v-if="v" color="success" size="18">
        mdi-check
      </v-icon>
      <span v-else class="grey--text text--lighten-1">—</span>
    </template>
  </BTableSimple>
</template>

<script>
import {
  TABLE_ACTIONS,
  TABLE_ACTIONS_ADMIN,
  TABLE_HEADERS,
} from '@/views/Publications/DataCollections/table-headers'
import { lkPublicationDataCollectionPermissions as Permissions } from '@/helpers/enums/permission-models'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePublicationDataCollections',
  components: {
    BTableSimple,
  },
  inheritAttrs: false,
  props: {
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
  computed: {
    filteredActions() {
      return this.$access(Permissions.edit) ? this.actions : TABLE_ACTIONS_ADMIN
    },
    hasAccessToTemplates() {
      return this.$access(Permissions.read)
    },
  },
}
</script>

<style lang="scss">
.BTablePublicationDataCollections {
  .col-name {
    min-width: 200px;
  }

  .col-ates {
    max-width: 600px;
  }

  .col-form_template {
    min-width: 200px;
    max-width: 480px;
  }
}
</style>
